import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { AlertDetailDrawerHostComponent } from './alert-detail-drawer-host.component';
import { AlertDetailDrawerComponent } from './alert-detail-drawer.component';
import { ClaimAlertDialogComponent } from './claim-alert-dialog.component';
import { MuteAlertDialogComponent } from './mute-alert-dialog.component';

/**
 * The alert-detail drawer, its shell host, and the two triage dialogs it opens. Lives in its own
 * (non-lazy) feature lib so the cloud-ziti app shell can mount the host eagerly — the Alerts page is
 * lazy-loaded, so hosting the drawer there would pull the whole page into the eager bundle (forbidden
 * by the module-boundary rule). PageAlertsModule imports this too, so the Alerts page uses the same drawer.
 */
@NgModule({
    declarations: [
        AlertDetailDrawerComponent,
        AlertDetailDrawerHostComponent,
        ClaimAlertDialogComponent,
        MuteAlertDialogComponent,
    ],
    exports: [AlertDetailDrawerComponent, AlertDetailDrawerHostComponent],
    imports: [CommonModule, FormsModule, MatDialogModule, RouterModule],
})
export class AlertDetailDrawerModule {}
